const TAB_SESSION_KEY = 'evitals_tab_session';

/** True when this browser tab still has an active login (cleared when tab/browser closes). */
export const hasActiveTabSession = () => {
  try {
    return sessionStorage.getItem(TAB_SESSION_KEY) === '1';
  } catch {
    return false;
  }
};

/** Mark this tab as logged in. Survives refresh, not tab/browser close. */
export const establishTabSession = () => {
  try {
    sessionStorage.setItem(TAB_SESSION_KEY, '1');
  } catch {
    // Ignore storage errors (private mode, quota, etc.)
  }
};

export const clearTabSession = () => {
  try {
    sessionStorage.removeItem(TAB_SESSION_KEY);
  } catch {
    // Ignore storage errors
  }
};
